<div class="relative mx-auto h-[231px] max-w-[384px] sm:h-[275px] sm:max-w-[1306px] overflow-hidden rounded-[10px] sm:rounded-[0px]">
  <ln-ln-image-frame
    [src]="imageUrl"
    [alt]="'imagesAlt.artisan' | transloco"
    [class]="'mx-auto flex h-[231px] w-full max-w-[383px] flex-row rounded-[10px] object-cover sm:h-[371px] sm:max-w-[1305px] sm:rounded-[0px]'"
  ></ln-ln-image-frame>
  <div class="absolute top-[62px] left-[21px] sm:top-[74px] sm:left-[53px]">
    <div class="max-w-[211px] h-[69px] sm:max-w-[515px] sm:h-[92px] text-blanco text-xl font-semibold sm:text-3xl leading-[1.25rem] sm:font-normal">
      {{'hero.blog.title' | transloco}}
    </div>
    <div class="max-w-[217px] h-[19px] sm:max-w-[515px] sm:h-[49px] mt-[16px] justify-start text-blanco text-sm sm:text-xl font-medium font-['Roboto']">{{'hero.blog.subTitle' | transloco}}</div>
  </div>
</div>
